import classNames from 'classnames';
import { isEmpty } from 'lodash';

import ErrorBlock from '../../../../../common/ErrorBlock';
import { SkeletonLoader } from '../../../../../components/SkeletonLoader';
import { useGetVouchers } from '../../../../../hooks/queries/useVoucherQuery';
import { TicketIcon } from '../../../../../icons/TicketIcon';
import { formatError } from '../../../../../util/errors';

export interface VoucherMessageProps {
  className?: string;
  body?: React.ReactNode;
}

export const VoucherMessage = ({ className, body }: VoucherMessageProps) => {
  const { data: vouchers, isLoading: isVoucherLoading, error: vouchersError } = useGetVouchers('Active');

  if (isEmpty(vouchers) && !isVoucherLoading) {
    return null;
  }

  return (
    <div
      className={classNames(
        'mb-10 rounded-lg border border-slate-2 bg-white px-6 py-5 shadow lg:mb-8 lg:p-10 lg:py-8',
        className
      )}
    >
      {isVoucherLoading && <SkeletonLoader className="mt-3 h-4" loading={isVoucherLoading} />}
      {vouchersError && <ErrorBlock errorMsg={formatError(vouchersError)} />}
      {vouchers && (
        <div className="flex flex-row gap-3">
          <div className="flex !w-6 items-start justify-center">
            <TicketIcon width={24} height={24} className="mt-[2px] fill-blood-orange-4" />
          </div>
          <div className="flex flex-col items-start gap-y-3">
            <p className="text-base font-bold">
              You have {vouchers.length} voucher{vouchers.length > 1 ? 's' : ''} available to use
            </p>
            <>{body}</>
          </div>
        </div>
      )}
    </div>
  );
};
